<template>
  <div>
    <div class="content md-layout md-gutter">
      <div
        class="md-layout-item md-xlarge-size-100 md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <div class="md-layout">
          <div
            class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-size-30 md-xsmall-size-50"
          >
            <img src="../assets/dslv_logo.svg" alt="DSLV Logo" />
          </div>
        </div>
        <p class="md-body-1">{{ $t("intro") }}</p>
      </div>

      <div
        class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
        v-for="questionnaire in $store.state.questionnaires"
        :key="questionnaire.identifier"
      >
        <QuestionnaireItem :questionnaire="questionnaire" />
      </div>
    </div>
    <footer class="md-layout md-alignment-center">
      <a href="https://skilehrerverband.de/impressum/">{{ $t("imprint") }} </a
      ><span> | </span>
      <a href="https://skilehrerverband.de/datenschutzbelehrung/">
        {{ $t("privacy-policy") }} </a
      ><span> | </span>
      <a
        href="https://skilehrerverband.de/onlinetheorie-anleitung-fuer-die-anwendung/"
      >
        {{ $t("instructions") }}
      </a>
    </footer>
  </div>
</template>

<i18n>
{
  "en": {
    "intro": "Please select the questionnaire you would like to complete.",
    "imprint": "Imprint",
    "privacy-policy": "Privacy Policy",
    "instructions": "Instructions"
  },
  "de": {
    "intro": "Bitte wähle den Fragebogen aus, den du bearbeiten möchtest.",
    "imprint": "Impressum",
    "privacy-policy": "Datenschutz",
    "instructions": "Anleitung"
  }
}
</i18n>

<script>
import QuestionnaireItem from "./QuestionnaireItem.vue";
export default {
  components: {
    QuestionnaireItem: QuestionnaireItem,
  },
};
</script>
<style scoped>
.md-layout-item {
  margin: 1% 0;
}
footer a {
  margin: 1%;
}
</style>
